<template>
<v-dialog 
    v-model="show_dialog" 
    max-width="800"
>

    <v-card>
    <v-card-title class="headline">
        Something has gone wrong...
    </v-card-title>

    <v-card-text>
        <p>Uh oh... Something has gone wrong with your request.</p>
        <p>In many cases the issue is momentary, in which case trying again in a minute should resolve the issue.  If it does not, please contact us for help.</p>
        <code 
            v-if="show_technical_details"
            style="display: block; white-space: pre;"
        >
            {{response_json_pretty_print}}
        </code>
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

         <v-btn
            color="gray darken-1"
            text
            @click="signOut"
        >
            Sign Out
        </v-btn>

         <v-btn
            color="gray darken-1"
            text
            @click="showTechnicalDetails"
            v-if="!show_technical_details"
        >
            Show technical details
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onReloadPage"
        >
            Reload Page
        </v-btn>
    </v-card-actions>
    </v-card>

</v-dialog>
    
</template>

<script>
export default {
    data() {
        return {
            show_dialog: false,
            response: null,
            show_technical_details: false,
            response_json_pretty_print: null,
        }
    },

    methods: {
        showDialog(response) {
            this.response = response;
            this.response_json_pretty_print = JSON.stringify(response,null,2);

            this.show_technical_details = false;

            this.show_dialog = true;
        },

        showTechnicalDetails()
        {
            this.show_technical_details = true;
        },

        onReloadPage()
        {
            location.reload();
        },

        signOut()
        {
            this.$rc.signOut();

            this.$router.push({
                'name': 'sign-in',
            }).catch(e=>{}); // swallow any exception
        },
    },
}
</script>

<style scoped>

</style>